/**
 * Sticky header functionality
 *
 * @package Embark
 * @since   1.0.0
 */

const { html, body, header } = embark.els;

export class StickyHeader {
	lastScrollTop = 0;

	options = {
		// Amount, in pixels, that the page should scroll before adding scrolledClass to this.el.
		// Can be an integer or a function that returns an integer.
		scrolledTarget: 100,
		// Class to add to this.el when scrolledTarget is reached.
		scrolledClass: 'scrolled',
		// Whether to hide the header at a certain scroll point or not.
		isHideOnScroll: true,
		// Amount, in pixels, that the page should scroll before adding hideOnScrollClass to this.el.
		// Can be an integer or a function that returns an integer.
		hideOnScrollTarget: () => window.innerHeight / 1.5,
		// Class to add to this.el when hideOnScrollTarget is reached.
		hideOnScrollClass: 'hide',
	};

	constructor(el, options = {}) {
		if (el) {
			this.el = el;

			if (options) {
				this.options = Object.assign(this.options, options);
			}

			document.addEventListener('scroll', this.handleScroll);
			this.handleScroll();
		}
	}

	/**
	 * Check the current scroll position and determine if the header should have a class added or removed.
	 */
	handleScroll = () => {
		window.requestAnimationFrame(() => {
			// Get the current scroll position.
			this.scrollTop = window.pageYOffset || html.scrollTop || body.scrollTop;

			// Add header classes based on scroll position.
			this.maybeAddScrolledClass();
			this.maybeAddHideOnScrollClass();

			// Update this.lastScrollTop for subsequenet comparisons within this function.
			this.lastScrollTop = this.scrollTop;
		});
	}

	maybeAddScrolledClass = () => {
		// The point (in pixels) at which the header class should be toggled.
		const scrollTarget = typeof this.options.scrolledTarget === 'function' ? this.options.scrolledTarget() : this.options.scrolledTarget;

		if (this.scrollTop >= scrollTarget) {
			this.el.classList.add(this.options.scrolledClass);
		} else {
			this.el.classList.remove(this.options.scrolledClass);
		}
	}

	maybeAddHideOnScrollClass = () => {
		if (this.options.isHideOnScroll) {
			// The point (in pixels) at which the header class should be toggled.
			const scrollTarget = typeof this.options.hideOnScrollTarget === 'function' ? this.options.hideOnScrollTarget() : this.options.hideOnScrollTarget;

			// Apply the hideOnScrollClass class if the user has scrolled past the scrollPoint and is scrolling down.
			if (this.scrollTop >= scrollTarget && this.scrollTop > this.lastScrollTop) {
				this.el.classList.add(this.options.hideOnScrollClass);
			} else if (this.scrollTop < this.lastScrollTop) {
				this.el.classList.remove(this.options.hideOnScrollClass);
			}
		}
	}
}

embark.components.stickyHeader = new StickyHeader(header);
